/* Bonitale vacuum bags — shared behavior for the vacuum-space landing.
   Used by theme/sections/bonitale-vacuum-bags.liquid.
   No quantity selector and no /cart/add.js calls: purchase runs entirely
   through the Releasit COD Form app (hook div + its own generated button). */
(function () {
  "use strict";

  function init(root) {
    document.body.classList.add("vsb-landing-active");
    initReleasitOffer(root);
    initReleasitButtonCopy();
    initGallery(root);
    initStickyCta(root);
    initCodProxy(root);
  }

  // Temporary storefront bridge: overrides whatever Releasit already has
  // configured for this product with the exact 3-tier offer confirmed for
  // launch (x5 / x10 / x15). Revision 69900-20260813 — update both this
  // comment and the numbers below together if the offer ever changes.
  // The Releasit `ds` values remain fixed discounts from the current sale
  // unit price so the checkout totals stay 69.900 / 109.900 / 139.900.
  // Savings plaques are calculated separately against the displayed regular
  // kit value of $116.500: 2×116.500−109.900=$123.100 and
  // 3×116.500−139.900=$209.600.
  function initReleasitOffer(root) {
    var productId = root.getAttribute("data-product-id");
    var groups = window._RSI_COD_FORM_QUANTIY_OFFERS;
    if (!productId || !Array.isArray(groups)) return;

    var target = groups.find(function (group) {
      return group && group.isActive && Array.isArray(group.pIds) && group.pIds.indexOf(productId) !== -1;
    });
    if (!target) {
      target = {
        id: Date.now(),
        type: "quantity-offer",
        isActive: true,
        name: "Bolsas organizadoras al vacío",
        pIds: [productId],
        offers: [],
        selBC: "rgba(46,111,224,1)",
        selBgC: "rgba(231,238,252,1)",
        borderRadius: 8,
        prSize: 14,
        hideImg: false,
        hideVN: false,
        disableVariantsUseFirstVariant: true,
        noShowIfQuantityIsGreater: false,
        useComparePrice: true,
        template: "classic"
      };
      groups.push(target);
    }

    var blue = "rgba(22,67,123,1)";
    var amber = "rgba(219,124,22,1)";
    var imageOne = root.getAttribute("data-offer-image-one") || "";
    var imageTwo = root.getAttribute("data-offer-image-two") || "";
    var imageThree = root.getAttribute("data-offer-image-three") || "";
    var current = Array.isArray(target.offers) ? target.offers : [];

    var five = Object.assign({}, current[0] || {}, {
      pos: 0, title: "5 bolsas de 70 × 50 cm + 1 bomba manual", qty: 1,
      ds: { t: "none", v: 0 }, pres: false, plaque: "Precio especial $69.900", imgUrl: imageOne,
      plaqueBgC: "rgba(237,241,248,1)", plaqueTC: blue,
      bestDealBadge: { show: false }
    });
    var ten = Object.assign({}, current[1] || {}, {
      pos: 1, title: "10 bolsas de 70 × 50 cm + 2 bombas manuales", qty: 2,
      ds: { t: "fixed", v: 2990000 }, pres: true, plaque: "Ahorras $123.100",
      plaqueBgC: blue, plaqueTC: "rgba(255,255,255,1)", imgUrl: imageTwo,
      bestDealBadge: {
        show: true, badgeContent: "Más elegido", badgeBgC: blue,
        badgeTC: "rgba(255,255,255,1)", badgeBR: 12, animation: "none", textAlign: "left"
      }
    });
    var fifteen = Object.assign({}, current[2] || current[1] || {}, {
      pos: 2, title: "15 bolsas de 70 × 50 cm + 3 bombas manuales", qty: 3,
      ds: { t: "fixed", v: 6980000 }, pres: false, plaque: "Ahorras $209.600",
      plaqueBgC: amber, plaqueTC: "rgba(255,255,255,1)", imgUrl: imageThree,
      bestDealBadge: {
        show: true, badgeContent: "Mejor precio por bolsa", badgeBgC: amber,
        badgeTC: "rgba(255,255,255,1)", badgeBR: 12, animation: "none", textAlign: "left"
      }
    });

    target.offers = [five, ten, fifteen];
    target.selBC = blue;
    target.selBgC = "rgba(231,238,252,1)";
    target.borderRadius = 8;
    target.useComparePrice = true;
    target.hideImg = false;
  }

  function initReleasitButtonCopy() {
    function polish() {
      var hook = document.querySelector(".vsb .cod-hook");
      var productButton = document.querySelector("#_rsi-buy-now-button._rsi-buy-now-button-product, ._rsi-buy-now-button-product");
      if (hook && productButton && !hook.contains(productButton)) {
        hook.appendChild(productButton);
      }
      var subtitle = productButton && productButton.querySelector("._rsi-buy-now-button-subtitle");
      if (subtitle) subtitle.textContent = "Elige tu pack y ahorra";
      return !!(hook && productButton && hook.contains(productButton));
    }

    if (polish()) return;
    var observer = new MutationObserver(function () {
      if (polish()) observer.disconnect();
    });
    observer.observe(document.documentElement, { childList: true, subtree: true });
  }

  function initGallery(root) {
    var galleries = root.querySelectorAll(".gallery");
    galleries.forEach(function (gallery) {
      var track = gallery.querySelector(".gallery-track");
      var slides = Array.prototype.slice.call(gallery.querySelectorAll(".gallery-slide"));
      var navButtons = Array.prototype.slice.call(gallery.querySelectorAll(".gallery-nav-btn"));
      if (!track || slides.length < 2) return;

      var reduceMotion = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
      var desktopQuery = window.matchMedia ? window.matchMedia("(min-width: 960px)") : null;
      var observer = null;

      function setActive(index) {
        slides.forEach(function (slide, i) {
          slide.classList.toggle("is-active", i === index);
        });
        navButtons.forEach(function (btn, i) {
          btn.setAttribute("aria-selected", i === index ? "true" : "false");
        });
      }

      function isDesktop() {
        return !!(desktopQuery && desktopQuery.matches);
      }

      // The swipe observer only runs in mobile mode, where the track actually
      // scrolls. On desktop all slides share the same absolutely-positioned
      // rect (stacked, toggled by opacity), so every slide would report as
      // simultaneously intersecting and fight over which one is "active".
      function attachSwipeObserver() {
        if (observer || !("IntersectionObserver" in window)) return;
        observer = new IntersectionObserver(
          function (entries) {
            var best = null;
            entries.forEach(function (entry) {
              if (entry.isIntersecting && (!best || entry.intersectionRatio > best.intersectionRatio)) {
                best = entry;
              }
            });
            if (best) {
              var index = slides.indexOf(best.target);
              if (index !== -1) setActive(index);
            }
          },
          { root: track, threshold: [0.6] }
        );
        slides.forEach(function (slide) {
          observer.observe(slide);
        });
      }

      function detachSwipeObserver() {
        if (!observer) return;
        observer.disconnect();
        observer = null;
      }

      function syncMode() {
        if (isDesktop()) {
          detachSwipeObserver();
        } else {
          attachSwipeObserver();
        }
      }

      navButtons.forEach(function (btn, i) {
        btn.addEventListener("click", function () {
          if (isDesktop()) {
            setActive(i);
          } else {
            slides[i].scrollIntoView({
              behavior: reduceMotion ? "auto" : "smooth",
              inline: "start",
              block: "nearest"
            });
          }
        });
      });

      setActive(0);
      syncMode();

      if (desktopQuery) {
        var onChange = function () { syncMode(); };
        if (desktopQuery.addEventListener) desktopQuery.addEventListener("change", onChange);
        else if (desktopQuery.addListener) desktopQuery.addListener(onChange);
      }
    });
  }

  function initStickyCta(root) {
    var sticky = root.querySelector(".sticky-cta");
    var sentinel = root.querySelector(".pain-section");
    if (!sticky || !sentinel) return;

    if ("IntersectionObserver" in window) {
      var observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            // The Interest section begins immediately after the purchase panel.
            // This distinguishes "still below the fold" from "already passed"
            // even when the page jumps several viewports in one frame.
            sticky.classList.toggle(
              "is-visible",
              entry.isIntersecting || entry.boundingClientRect.top < 0
            );
          });
        },
        { threshold: 0 }
      );
      observer.observe(sentinel);
    } else {
      sticky.classList.add("is-visible");
    }
  }

  // Proxies clicks to the button Releasit COD Form generates. Until that app
  // script has mounted, falls back to scrolling/focusing the COD form region so
  // the real trigger is always reachable — never submits our own cart request.
  function initCodProxy(root) {
    var proxyButtons = root.querySelectorAll("[data-cod-proxy]");
    if (!proxyButtons.length) return;

    function activateReleasit() {
      var realButton = document.querySelector("#_rsi-buy-now-button, ._rsi-buy-now-button");
      if (realButton) {
        realButton.click();
        return;
      }
      var hook = root.querySelector(".cod-hook");
      if (hook) {
        hook.scrollIntoView({ behavior: "smooth", block: "center" });
        if (!hook.hasAttribute("tabindex")) hook.setAttribute("tabindex", "-1");
        hook.focus({ preventScroll: true });
      }
    }

    proxyButtons.forEach(function (button) {
      button.addEventListener("click", activateReleasit);
    });
  }

  // Shopify sections can't edit <head>; inject a description only if the
  // theme/layout didn't already provide one, so Lighthouse SEO passes without
  // touching global layout markup.
  function ensureMetaDescription() {
    if (document.querySelector('meta[name="description"]')) return;
    var meta = document.createElement("meta");
    meta.setAttribute("name", "description");
    meta.setAttribute(
      "content",
      "Bolsas organizadoras al vacío Bonitale, 5 unidades de 70 × 50 cm con bomba manual, para compactar cobijas, cubrelechos, almohadas y ropa y recuperar espacio en el clóset o la maleta."
    );
    document.head.appendChild(meta);
  }

  function removeMalformedThemeArtifact() {
    Array.prototype.slice.call(document.body.children).forEach(function (node) {
      if (node.tagName === "DIV" && node.children.length === 0 && node.textContent.trim() === "â–¡") {
        node.remove();
      }
    });
  }

  function boot() {
    ensureMetaDescription();
    removeMalformedThemeArtifact();
    document.querySelectorAll(".vsb").forEach(init);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }
})();
